import { Barcodes } from '@pos/app/scripts/services/barcodes';

export class Sku {
  constructor(
    private $q: ng.IQService,
    private barcodes: Barcodes,
    private legacySku,
  ) {}

  get = (barcode) => {
    // wrap to promise
    if (this.barcodes.contain(barcode)) {
      return this.$q.when(this.barcodes.get(barcode));
    }

    if (this.barcodes.contain('000' + barcode)) {
      return this.$q.when(this.barcodes.get('000' + barcode));
    }

    if (this.barcodes.contain('0' + barcode)) {
      return this.$q.when(this.barcodes.get('0' + barcode));
    }

    if (
      barcode.length === 13 &&
      barcode[0] === '0' &&
      this.barcodes.contain(barcode.substring(1))
    ) {
      return this.$q.when(this.barcodes.get(barcode.substring(1)));
    }

    return this.legacySku.get(barcode);
  };
}

/*
 * Service sku
 */
angular
  .module('posApp')
  .factory('sku', ($q: ng.IQService, barcodes: Barcodes, legacySku) => {
    return new Sku($q, barcodes, legacySku);
  });
